module.exports = __webpack_public_path__ + "static/media/thermometer-three-quarters.247169e8.svg";